<nav [ngStyle]="{'background': bgHeader != null ? bgHeader : ''}" class="navbar navbar-expand-md navbar-light fixed-top p-0 flex-wrap" id="menutop">
    <div class="container-fluid">
        <div class="d-flex justify-content-between align-items-center flex-grow-1">
            <div class="logo">
                <ng-container *ngIf="logotag == '' || logotag == null else showLogoTag">
                    <ng-container *ngIf="logo$ | async as logo; else logoSkeleton">
                        <ng-container *ngIf="loadingCompany == false else logoSkeleton">
                            <a *ngIf="companyId != '6a513fd7-cc7e-48d2-9cd0-4f51abb57854'" class="d-flex align-items-center h-100" routerLink="/">
                                <img alt="Logo" [src]="logo">
                            </a>
                            <a *ngIf="companyId == '6a513fd7-cc7e-48d2-9cd0-4f51abb57854'" class="d-flex align-items-center h-100" routerLink="/">
                                <img src="../../../../assets/images/chamatickets.png" />
                            </a>                        
                        </ng-container>
                        <ng-template #logoSkeleton>
                            <ngx-skeleton-loader
                                [theme]="{ 
                                    width: '100%', 
                                    height: '100%'
                                }"
                            ></ngx-skeleton-loader>
                        </ng-template>
                    </ng-container>
                    <ng-template #logoSkeleton>
                        <ngx-skeleton-loader
                            [theme]="{ 
                                width: '100%', 
                                height: '100%'
                            }"
                        ></ngx-skeleton-loader>
                    </ng-template>
                </ng-container> 
                <ng-template #showLogoTag>
                    <ng-container *ngIf="logotag; else logoSkeleton">
                        <ng-container *ngIf="loadingCompany == false else logoSkeleton">
                            <a class="d-flex align-items-center h-100" routerLink="/">
                                <img [src]="logotag">
                            </a>
                            <a *ngIf="companyId == '6a513fd7-cc7e-48d2-9cd0-4f51abb57854'" class="d-flex align-items-center h-100" routerLink="/">
                                <img [src]="logotag" />
                            </a>
                        
                        </ng-container>
                        <ng-template #logoSkeleton>
                            <ngx-skeleton-loader
                                [theme]="{ 
                                    width: '100%', 
                                    height: '100%'
                                }"
                            ></ngx-skeleton-loader>
                        </ng-template>
                    </ng-container>
                    <ng-template #logoSkeleton>
                        <ngx-skeleton-loader
                            [theme]="{ 
                                width: '100%', 
                                height: '100%'
                            }"
                        ></ngx-skeleton-loader>
                    </ng-template>
                </ng-template>
            </div>

            <div class="filters mx-3" *ngIf="showFilter == true">
                <app-menu-cities 
                    [selected]="filteredState$ | async"
                    [cities]="cities$ | async" 
                    (stateChanged)="selectState($event)"
                ></app-menu-cities>

                <form class="searchform">
                    <div class="d-flex input-group">
                        <input class="form-control" type="text" placeholder="Pesquisar" aria-label="Pesquisar" name="search" [(ngModel)]="search" (ngModelChange)="searched()">
                        <button class="form-control search">
                            <i class="las la-search text-grad"></i>
                        </button>
                    </div>
                </form>
            </div>
            <div class="menu-right d-none d-md-flex justify-content-end align-items-center gap-4 ms-3 ms-sm-0">
                <div *ngIf="showFilter == true" class="search">
                    <button class="navbar-toggler me-1" type="button" (click)="showHideSearch()"                   
                        aria-expanded="false" aria-label="Toggle navigation">
                        <i class="las la-search text-grad"></i>
                    </button>
                </div>
                <div class="d-md-none">
                <div *ngIf="logged == true || loggedProducer == true">
                    <div *ngIf="logged == true">
                        <app-menu-customer (logout)="getLogout($event)"></app-menu-customer>
                    </div>
                    <div *ngIf="loggedProducer == true">
                        <app-menu-producer (logout)="getLogout($event)"></app-menu-producer>
                    </div>
                </div>
            </div>
                <ng-container class="d-none d-md-flex justify-content-between align-items-center w-100" *ngIf="logged == false && loggedProducer == false">
                   
                        <div class="login">
                            <a href="#"  class="d-flex align-items-center text-decoration-none text-nowrap btn btn-grad" [routerLink]="['/auth/login']">
                                Entrar
                                <!-- <i class="las la-user-circle ms-1"></i> -->
                            </a>
                        </div>
                        <div class="register">
                            <button class="btn btn-grad text-truncate" [routerLink]="['/auth/register']">Cadastre-se</button>
                        </div>

                    <ng-container *ngIf="showBeOurPartner">
                        <a 
                            target="_blank" 
                            class="d-none d-md-flex align-items-center text-decoration-none gap-1"
                            href="https://docs.google.com/forms/d/16Ws575xORYZUZAxJvONgIr9W-i_dtS_c1GHpC7Ko238"
                            *ngIf="logged == false"
                        >
                            <img width="37px" src="../../../../../../assets/icons/parceiro.png">
                            <p class="onlyhand text-grad text-nowrap" style="font-size: 1.1rem;font-weight: 500;transition: 0.2s;">Seja nosso parceiro</p>
                        </a>
                    </ng-container>
                    <ng-container *ngIf="showLgpd">
                        <a 
                            target="_blank" 
                            class="d-none d-md-flex align-items-center text-decoration-none gap-1"
                            href="https://ingressosa.com/lgpd"
                            *ngIf="logged == false"
                        >
                            <p class="onlyhand text-grad text-nowrap" style="font-size: 1.1rem;font-weight: 500;transition: 0.2s;"><img width="30" class="me-1" style="width: 25px;" src="../../../../assets/icons/facial.png" /> POLÍTICA DE BIOMETRIA</p>
                        </a>
                    </ng-container>
                </ng-container>
            </div>
        </div>
        <div *ngIf="showFilter == true" class="search d-md-none d-sm-flex">
            <button class="navbar-toggler me-1" type="button" (click)="showHideSearch()"                   
                aria-expanded="false" aria-label="Toggle navigation">
                <i class="las la-search" [ngStyle]="{'color': whiteColor != null && whiteColor ? 'white' : 'black'}"></i>
            </button>
        </div>
        <div *ngIf="logged == false  && loggedProducer ==  false" class="d-md-none d-sm-block p-3"  (click)="showHideMenu()" style="top: 70px; right: 0;cursor:pointer">

            <i class="las la-bars fs-4" [ngStyle]="{'color': whiteColor != null && whiteColor ? 'white' : 'black'}"></i>
        </div>
        <div *ngIf="logged == true || loggedProducer == true">
            <div *ngIf="logged == true">
                <app-menu-customer (logout)="getLogout($event)"></app-menu-customer>
            </div>
            <div *ngIf="loggedProducer == true">
                <app-menu-producer (logout)="getLogout($event)"></app-menu-producer>
            </div>
        </div>
    </div>
    
    <div *ngIf="(logged == false  || loggedProducer ==  false) && showMenu" class="border position-absolute d-md-none  d-block bg-white p-3" style="top: 70px; right: 0">
        <div class="flex justify-content-start">
           
                <div class="login">
                    <a href="#"
                        class="d-flex align-items-center text-decoration-none text-nowrap text-grad"
                        [routerLink]="['/auth/login']">
                        Entrar
                        <!-- <i class="las la-user-circle ms-1"></i> -->
                    </a>
                </div>
                <div class="register mt-2">
                    <button class="btn btn-grad text-truncate" [routerLink]="['/auth/register']">Cadastre-se</button>
                </div>
         
            <ng-container *ngIf="showBeOurPartner">
                <a target="_blank" class="d-none d-md-flex align-items-center text-decoration-none gap-1"
                    href="https://docs.google.com/forms/d/16Ws575xORYZUZAxJvONgIr9W-i_dtS_c1GHpC7Ko238"
                    *ngIf="logged == false">
                    <img width="37px" src="../../../../../../assets/icons/parceiro.png">
                    <p class="onlyhand text-grad text-nowrap"
                        style="font-size: 1.1rem;font-weight: 500;transition: 0.2s;">Seja nosso parceiro</p>
                </a>
            </ng-container>
            <ng-container *ngIf="showLgpd">
                <a target="_blank" class="flex align-items-center text-decoration-none gap-1"
                    href="https://ingressosa.com/lgpd" *ngIf="logged == false">
                    <p class="text-grad mt-4 text-nowrap"
                        style="font-size: 13px;font-weight: 500;transition: 0.2s;"><img width="30" style="width: 30px;" src="../../../../assets/icons/facial.png" /> POLÍTICA DE BIOMETRIA</p>
                </a>
            </ng-container>
        </div>

    </div>
    <ng-container *ngIf="showFilter == true">
        <div *ngIf="hideSearch == false" class="filters-mobile w-100" id="navbarToggleExternalContent">
            <div class="d-flex align-items-center p-3 flex-wrap w-100">
                <div class="col-lg-4 mt-3 col-12">
                    <app-menu-cities 
                        [selected]="filteredState$ | async"
                        [cities]="cities$ | async" 
                        (stateChanged)="selectState($event)"
                    ></app-menu-cities>
                </div>
                <div class="col-lg-4 mt-3 col-12">
                    <form class="searchform w-100 ms-1">
                        <div class="d-flex input-group">
                            <input class="form-control" type="text" placeholder="Pesquisar" name="search" [(ngModel)]="search" (ngModelChange)="searched()" aria-label="Pesquisar">
                            <button class="form-control search">
                                <i class="las la-search text-grad"></i>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </ng-container>
</nav>
